<template>
  <div class="sticky-download">
    <router-link to="/download/">⬇ Download GBWhatsApp APK</router-link>
  </div>
</template>

<script>
export default {
  name: 'StickyDownload',
};
</script>
